/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

Number.prototype.pad = function (size) {
  var s = String(this);
  while (s.length < (size || 2)) {
    s = "0" + s;
  }
  return s;
};

Date.prototype.toDateInputValue = function () {
  // var local = new Date(this);
  return this.toJSON().slice(0, 10);
};

Date.prototype.toStandardDate = function () {
  let d = this.toLocaleDateString().split("/");
  d = d.map((i) => (i.length < 2 ? `0${i}` : i));
  return `${d[2]}-${d[0]}-${d[1]}`;
};

Date.prototype.toShortDateFormat = function () {
  var d = new Date(this);
  //get the month
  var month = d.getMonth();
  //get the day
  //convert day to string
  var day = d.getDate().toString();
  //get the year
  var year = d.getFullYear();

  //pull the last two digits of the year
  year = year.toString().substr(-2);

  //increment month by 1 since it is 0 indexed
  //converts month to a string
  month = (month + 1).toString();

  //return the string "M/d/yy"
  return `${month}/${day}/${year}`;
};

Date.prototype.toShortDate = function () {
  var d = new Date(this);
  //get the month
  var month = d.getMonth();
  //get the day
  //convert day to string
  var day = d.getDate().toString();
  //get the year
  var year = d.getFullYear();

  //pull the last two digits of the year
  year = year.toString().substr(-2);

  //increment month by 1 since it is 0 indexed
  //converts month to a string
  month = (month + 1).toString();

  //return the string "M/d/yy"
  return `${month}/${day}`;
};

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Date.prototype.addMonths = function (months) {
  var d = new Date(this);
  return new Date(d.setMonth(d.getMonth() - months));
};

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const addTimeToDateString = (time) => {
  return time + " 00:00:00";
};
